import { FC } from "react";
import { StepsProps } from "../../types";
import { FormProvider } from "react-hook-form";
import useStep2 from "./useStep2";
import {
  FormDatePicker,
  FormInput,
  FormSectionHeader,
  Loader,
} from "@/components";
import {
  CAM_LICENSE_END_DATE,
  CAM_LICENSE_NO,
  CAM_LICENSE_START_DATE,
  FED_TAX_ID,
  FILLING_DUE_DATE,
  LAST_AGM_DATE,
  STATE_TAX_ID,
} from "./consts";
import moment from "moment";

const Step2: FC<StepsProps> = ({ isView }) => {
  const {
    form,
    requiredFields,
    isLicenseInfoLoading,
    isLicenseInfoRefetching,
  } = useStep2();
  const { errors } = form.formState;

  return isLicenseInfoLoading || isLicenseInfoRefetching ? (
    <Loader />
  ) : (
    <FormProvider {...form}>
      <form>
        <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
          <div>
            <FormSectionHeader>
              License and Regulatory Information
            </FormSectionHeader>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
              <FormInput
                name={FED_TAX_ID}
                control={form.control}
                label="Community Fed Tax ID"
                placeholder="Please enter"
                error={errors[FED_TAX_ID]?.message}
                isRequired={requiredFields.includes(FED_TAX_ID)}
                disabled={isView}
                // format={formatFederalTaxId}
              />
              <FormInput
                name={STATE_TAX_ID}
                control={form.control}
                label="Community State Tax ID"
                placeholder="Please enter"
                error={errors[STATE_TAX_ID]?.message}
                isRequired={requiredFields.includes(STATE_TAX_ID)}
                disabled={isView}
                // format={formatFederalTaxId}
              />
              <FormInput
                name={CAM_LICENSE_NO}
                control={form.control}
                label="CAM License Number"
                placeholder="Please enter"
                error={errors[CAM_LICENSE_NO]?.message}
                isRequired={requiredFields.includes(CAM_LICENSE_NO)}
                disabled={isView}
              />
              {form.watch(CAM_LICENSE_NO) && (
                <>
                  <FormDatePicker
                    name={CAM_LICENSE_START_DATE}
                    control={form.control}
                    label="CAM License Start Date"
                    placeholder="Please select"
                    error={errors[CAM_LICENSE_START_DATE]?.message}
                    isRequired={form.watch(CAM_LICENSE_NO)}
                    disabled={isView}
                    maxDate={new Date()}
                    onClear={() => form.setValue(CAM_LICENSE_END_DATE, "")}
                    onChange={(date: any) => {
                      if (
                        moment(date).isAfter(
                          form.getValues()[CAM_LICENSE_END_DATE]
                        )
                      ) {
                        form.setValue(CAM_LICENSE_END_DATE, "");
                      }
                    }}
                  />
                  <FormDatePicker
                    name={CAM_LICENSE_END_DATE}
                    control={form.control}
                    label="CAM License End Date"
                    placeholder="Please select"
                    error={errors[CAM_LICENSE_END_DATE]?.message}
                    isRequired={form.watch(CAM_LICENSE_NO)}
                    disabled={isView || !form.watch(CAM_LICENSE_START_DATE)}
                    minDate={new Date(form.watch(CAM_LICENSE_START_DATE))}
                  />
                </>
              )}
              <FormDatePicker
                name={LAST_AGM_DATE}
                control={form.control}
                label="Last AGM Date"
                placeholder="Please select"
                error={errors[LAST_AGM_DATE]?.message}
                isRequired={requiredFields.includes(LAST_AGM_DATE)}
                disabled={isView}
                maxDate={new Date()}
              />
              <FormDatePicker
                name={FILLING_DUE_DATE}
                control={form.control}
                label="Annual Filling Due Date"
                placeholder="Please select"
                error={errors[FILLING_DUE_DATE]?.message}
                isRequired={requiredFields.includes(FILLING_DUE_DATE)}
                disabled={isView}
              />
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default Step2;
